/** Build tenant-scoped paths for the mobile label-link flow. */
export function labelLinkBasePath(subdomain: string | null): string {
  const prefix = subdomain ? `/${subdomain}` : '';
  return `${prefix}/labels/link`;
}

export function labelLinkHubPath(subdomain: string | null): string {
  return labelLinkBasePath(subdomain);
}

export function labelLinkScanPath(subdomain: string | null, containerId?: number): string {
  const base = `${labelLinkBasePath(subdomain)}/scan`;
  if (containerId === undefined) {
    return base;
  }
  return `${base}?containerId=${containerId}`;
}

export function labelLinkPickPath(
  subdomain: string | null,
  barcode: string,
  containerId?: number,
): string {
  const params = new URLSearchParams({ barcode });
  if (containerId !== undefined) {
    params.set('containerId', String(containerId));
  }
  return `${labelLinkBasePath(subdomain)}/pick?${params.toString()}`;
}

export function labelLinkDonePath(
  subdomain: string | null,
  barcode: string,
  containerId: number,
  containerName: string,
): string {
  const params = new URLSearchParams({
    barcode,
    containerId: String(containerId),
    containerName,
  });
  return `${labelLinkBasePath(subdomain)}/done?${params.toString()}`;
}

export function labelLinkLinkedPath(
  subdomain: string | null,
  barcode: string,
  entityType: string,
  entityId: number,
  entityName?: string,
): string {
  const params = new URLSearchParams({
    barcode,
    entityType,
    entityId: String(entityId),
  });
  if (entityName) {
    params.set('entityName', entityName);
  }
  return `${labelLinkBasePath(subdomain)}/linked?${params.toString()}`;
}

export function labelLinkHandheldPath(subdomain: string | null): string {
  return `${labelLinkBasePath(subdomain)}/handheld`;
}

export function getTenantCleanPath(pathname: string, subdomain: string | null): string {
  if (subdomain && pathname.startsWith(`/${subdomain}`)) {
    return pathname.slice(`/${subdomain}`.length) || '/';
  }
  return pathname;
}

export type LabelLinkSegment = 'hub' | 'scan' | 'pick' | 'done' | 'linked' | 'handheld';

export function parseLabelLinkSegment(cleanPath: string): LabelLinkSegment | null {
  if (cleanPath === '/labels/link') {
    return 'hub';
  }
  if (cleanPath === '/labels/link/handheld') {
    return 'handheld';
  }
  if (cleanPath === '/labels/link/scan') {
    return 'scan';
  }
  if (cleanPath === '/labels/link/pick') {
    return 'pick';
  }
  if (cleanPath === '/labels/link/done') {
    return 'done';
  }
  if (cleanPath === '/labels/link/linked') {
    return 'linked';
  }
  return null;
}
